(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-manifesto"] && !Shopify.designMode) return;
  try {
    
function initBrandManifestoSliders(root){
  root.querySelectorAll('[data-manifesto-slider]:not([data-manifesto-ready])').forEach((slider)=>{
    slider.dataset.manifestoReady='true';
    const track=slider.querySelector('.ps-brand-manifesto__slider');
    const count=slider.querySelector('[data-manifesto-count]');
    const slides=track.querySelectorAll('.ps-brand-manifesto__slide');
    const update=()=>{const index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));count.textContent=String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0')};
    const move=(direction)=>{const index=Math.round(track.scrollLeft/track.clientWidth);track.scrollTo({left:((index+direction+slides.length)%slides.length)*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};
    slider.querySelector('[data-manifesto-prev]').addEventListener('click',()=>move(-1));
    slider.querySelector('[data-manifesto-next]').addEventListener('click',()=>move(1));
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',(event)=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});
    window.addEventListener('resize',update,{passive:true});
  });
}
initBrandManifestoSliders(document);
document.addEventListener('shopify:section:load',(event)=>initBrandManifestoSliders(event.target));

  } catch(e) { console.error(e); }
})();
})();
